import './ProgressBar.min.css'

interface ProgressBarProps {
   show: boolean;
}

export default function ProgressBar({ show }: ProgressBarProps) {
   return (
      <div className={`progress-bar-container ${show ? "visible" : ""}`}>
         <div className="progressbar-overlay"></div>
         <progress className={`progressbar ${show ? "visible" : ""}`} />
      </div>
   );
}